import { ColorTypes, TintTypes } from '@folx-types/theme';

import { Tint } from '@theme/FlowThemes/FlowThemes';
import theme from '@theme/FolxTheme';

type GetColor = (color: ColorTypes, tint?: TintTypes) => string;
export const getColor: GetColor = (color: ColorTypes, tint?: TintTypes) => {
	return tint ? theme.tints[tint](theme.colors[color]) : theme.colors[color];
};

type GetColorFromTheme = (color: string, tint?: Tint) => string;
export const getColorFromTheme: GetColorFromTheme = (color, tint) => {
	return tint ? tint(color) : color;
};
